import { useEffect } from 'react';
import { useParametricStore } from '../store/parametricStore';
import { AuthService } from '../auth';

/**
 * Hook to initialize parametric data when the app starts
 * This replaces the ParametricProvider functionality
 */
export const useInitializeParametricData = () => {
  const { fetchAllParametricData, loading, error } = useParametricStore();

  useEffect(() => {
    // Only fetch if user is authenticated
    const isAuthenticated = AuthService.isAuthenticated();
    if (isAuthenticated) {
      fetchAllParametricData();
    }
  }, [fetchAllParametricData]);

  return { loading, error };
};